var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContribution({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4551 10.8327C17.1142 9.88785 17.5007 8.73868 17.5007 7.49935C17.5007 4.27769 14.889 1.66602 11.6673 1.66602C8.44565 1.66602 5.83398 4.27768 5.83398 7.49935C5.83398 8.39402 6.03539 9.2416 6.39534 9.99935",
    stroke: "#1E201C",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 5C10.7462 5 10 5.55964 10 6.25C10 6.94036 10.7462 7.5 11.6667 7.5C12.5872 7.5 13.3333 8.05964 13.3333 8.75C13.3333 9.44033 12.5872 10 11.6667 10M11.6667 5C12.3923 5 13.0097 5.34783 13.2385 5.83333M11.6667 5V3.75M11.6667 10C10.941 10 10.3237 9.65217 10.0948 9.16667M11.6667 10V11.25",
    stroke: "#1E201C",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 11.666H5L7.08333 12.8119H7.91667C9.16667 12.8119 10 13.7693 10 14.5825L7.5 15.4158L5 14.5825M9.99942 14.166L13.5086 12.9963C14.3458 12.7173 15.2553 13.1391 15.5831 13.9584L15.8328 14.5827L8.33276 18.3327L2.5 16.6826",
    stroke: "#1E201C",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContribution);
export default __webpack_public_path__ + "static/media/contribution.fbf8e8587f4e2404a7e352a2b8d17a55.svg";
export { ForwardRef as ReactComponent };